export const permissionsKeys = {
  page: 'micro-sites.dynamic-sites.page-block.find',
  pageBlockFind: 'micro-sites.dynamic-sites.page-block.find',
  // pageBlockCreate: 'micro-sites.dynamic-sites.page-block.create',
  // Cambios permisos daiber
  pageBlockCreate: 'content-management.page-dynamic.create',
  pageBlockUpdate: 'micro-sites.dynamic-sites.page-block.update',
  pageBlockRemove: 'micro-sites.dynamic-sites.page-block.remove',
  pageBlockUpdatePublish: 'micro-sites.dynamic-sites.publish.page-block.update',
  pageBlockUpdateStatusToDraft: 'micro-sites.dynamic-sites.draft.page-block.update',
  pageBlockUpdateInactivate: 'micro-sites.dynamic-sites.inactivate.page-block.update',
} as const;
export type TemplatePermissionsKeys = typeof permissionsKeys;
